"use client";

import { useParams } from "next/navigation";
import { LuCopy } from "react-icons/lu";

import CopyToClipboard from "@/components/shared/copy-to-clipboard";
import { Button } from "@/components/ui/button";

const BountyActionItems = () => {
  const params = useParams();
  const currentPage =
    typeof window !== "undefined"
      ? `${window.location.origin}/bounty/${params.username}`
      : "N/A";

  return (
    <div className="flex items-center gap-4">
      <CopyToClipboard
        text={currentPage}
        showIcon={false}
        showToast={true}
        toastText="The link has been successfully copied to your clipboard."
      >
        <Button variant="outline" className="flex items-center gap-2">
          <LuCopy className="text-muted" />
          Copy Link
        </Button>
      </CopyToClipboard>
    </div>
  );
};

export default BountyActionItems;
